import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

/**
 * EmptyState - A reusable component for displaying empty states
 * @param {string} title - The main title text
 * @param {string} description - Optional description text
 * @param {ReactNode} icon - Optional custom icon
 * @param {ReactNode} action - Optional action button/component
 */
const EmptyState = ({ 
  title = 'Δεν βρέθηκαν δεδομένα', 
  description, 
  icon,
  action 
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 6,
        textAlign: 'center',
        minHeight: 300,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 80,
          height: 80,
          borderRadius: '50%',
          backgroundColor: theme.palette.action.hover,
          color: theme.palette.text.secondary,
          mb: 3,
        }}
      >
        {icon || <InboxOutlinedIcon sx={{ fontSize: 40 }} />}
      </Box>
      
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          color: theme.palette.text.primary,
          mb: 1,
        }}
      >
        {title}
      </Typography>
      
      {description && (
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            maxWidth: 400,
            mb: action ? 3 : 0,
          }}
        >
          {description}
        </Typography>
      )}
      
      {action && (
        <Box sx={{ mt: 2 }}>
          {action}
        </Box>
      )}
    </Box>
  );
};

export default EmptyState;

